'use client';

import { useEffect } from 'react';
import { TokenManager } from '@/lib/auth/token-manager';

/**
 * Composant invisible qui s'occupe de synchroniser les tokens entre localStorage et cookies,
 * et d'initialiser le rafraîchissement automatique des tokens.
 * Ce composant doit être placé au niveau racine de l'application.
 */
export function TokenSynchronizer() {
  useEffect(() => {
    console.log('🔄 TokenSynchronizer: Initialisation');
    
    // Initialiser le rafraîchissement automatique des tokens
    TokenManager.initTokenRefresh();
    
    // Vérifier immédiatement si le token a besoin d'être rafraîchi
    TokenManager.checkAndRefreshToken().then(refreshed => {
      if (refreshed) {
        console.log('🔄 TokenSynchronizer: Token rafraîchi avec succès au démarrage');
      } else {
        console.log('🔄 TokenSynchronizer: Aucun rafraîchissement nécessaire au démarrage');
      }
    }).catch(error => {
      console.error('🔄 TokenSynchronizer: Erreur lors du rafraîchissement initial', error);
    });
    
    // Créer un header personnalisé pour les requêtes fetch
    const originalFetch = window.fetch;
    window.fetch = async function(input, init) {
      // Ne pas modifier les requêtes vers des domaines externes
      if (typeof input === 'string' && (
          input.startsWith('http') && 
          !input.includes('cyber-threat-consulting.com') && 
          !input.includes(window.location.host)
      )) {
        return originalFetch(input, init);
      }
      
      // Ajouter le token d'authentification aux en-têtes si disponible
      const token = TokenManager.getAccessToken();
      if (token) {
        init = init || {};
        init.headers = init.headers || {};
        // @ts-ignore - L'objet headers peut être de différents types
        init.headers = {
          ...init.headers,
          'Authorization': `Bearer ${token}`,
          'x-sentinel-token': token
        };
      }
      
      return originalFetch(input, init);
    };
    
    // Nettoyer lors du démontage du composant
    return () => {
      TokenManager.stopTokenRefresh();
      // Restaurer la fonction fetch originale
      window.fetch = originalFetch;
    };
  }, []);
  
  // Ce composant ne rend rien
  return null;
}

export default TokenSynchronizer;
